var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1446",
    fillRule: "evenodd",
    d: "M1.822 0h7.81a1 1 0 0 1 .845 1.537L6.57 7.674a1 1 0 0 1-1.687 0L.978 1.537A1 1 0 0 1 1.822 0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.4e474963e205766ffdc128351200b2df.svg";
export { ForwardRef as ReactComponent };